export default __webpack_public_path__ + "static/media/avatar-user.c180cf13.svg";